import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { composeValidations, PASSWORD_VALIDATION_LIST } from 'common/forms/FormValidationHelper';
import { Form, Input } from 'ui/base';
import { humanize } from 'utils/global';

import { PasswordErrors } from './PasswordErrors';

const validators = Object.entries(PASSWORD_VALIDATION_LIST).map(
  ([test, regex]) =>
    value =>
      (regex.test(value) ? undefined : `page.user.error.password.${test}`)
);

/** @type {React.FC<{ value: string, error: string, summarize: boolean }>} */
const FormattedError = ({ value, error, summarize }) =>
  (summarize ? <PasswordErrors password={value} /> : <FormattedMessage id={error} defaultMessage={humanize(error)} />);

/** @type {React.FC<{ label: string, shortError: boolean, hideErrorMessage?: boolean }>} */
const Password = ({ label, shortError, hideErrorMessage }) => {
  const intl = useIntl();

  return (
    <Field
      name="password"
      validate={composeValidations(...validators)}
      validateFields={['passwordConfirm']}
      subscription={{ value: true, touched: true, error: true }}
    >
      {({ input, meta }) => {
        const validateStatus = meta.error && meta.touched ? 'error' : '';
        const displayError = !hideErrorMessage && validateStatus === 'error';
        return (
          <Form.Item
            required
            label={label}
            className="ant-form-vertical"
            validateStatus={validateStatus}
            help={displayError && <FormattedError value={input.value} error={meta.error} summarize={!shortError} />}
          >
            <Input.Password
              {...input}
              data-cy="input-password"
              autoComplete="new-password"
              placeholder={intl.formatMessage({ id: 'password', defaultMessage: 'Password' })}
            />
          </Form.Item>
        );
      }}
    </Field>
  );
};

export default Password;
